import { render, staticRenderFns } from "./Union.vue?vue&type=template&id=61b78d15&"
import script from "./Union.vue?vue&type=script&lang=js&"
export * from "./Union.vue?vue&type=script&lang=js&"
import style0 from "./Union.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports